import { GuidUtility } from "../../../utility/common/GuidUtility.js";


export class ServiceTreeNodeItem
{   
    constructor()
    {   
        this.id=null;
        this.name=null;
        this.type=null;
        this.parentId=null;
        this.parent=null;
        this.children=new Array;
        this.serviceObject=null;
        this.checkedStatus=false;
    }


    static createTreeNodeItems(mapServices)
    {   
        let nodeItems=new Array();
        if(!mapServices)return nodeItems;

        let tempNodeItem=null;
        let tempMapService=null;
        for(let tempIndex=0;tempIndex<mapServices.objects.length;tempIndex++ )
        {   
            tempMapService=mapServices.objects[tempIndex];
            tempNodeItem=new ServiceTreeNodeItem();
            tempNodeItem.id=tempMapService.serviceId;
            tempNodeItem.name=tempMapService.serviceName;
            tempNodeItem.type=tempMapService.serviceType;
            tempNodeItem.serviceObject=tempMapService;

            nodeItems.push(tempNodeItem);
        }   

        return nodeItems;
    }


    static createRootNodeItems(mapServices)
    {   
        let nodeItems=new Array();
        if(!mapServices)return nodeItems;

        let classifies = mapServices.classifyByType();
        
        let tempServices=null;
        let tempTreeItem=null;
        for(let tempType in classifies)
        {   
            if(tempType==null)continue;

            tempServices = classifies[tempType];

            if( tempServices ==null || tempServices.objects ==null || tempServices.objects.length==0)continue;
            
            tempTreeItem=new ServiceTreeNodeItem();
            tempTreeItem.id=GuidUtility.getGuid();
            tempTreeItem.name=tempServices.objects[0].serviceTypeDesc;
            tempTreeItem.type=tempType;
            tempTreeItem.children=ServiceTreeNodeItem.createTreeNodeItems(tempServices);

            nodeItems.push(tempTreeItem);
        }

        return nodeItems;
    }


}

export const UCMapServiceEvent=
{       
    UCMapServiceTree_nodeItemCheckChange:"event_UCMapServiceTree_nodeItemCheckChange"



}